<template>
  <div>
    <div class="field">
      <label class="label">Имя</label>

      <div class="columns">
        <div class="column">
          <div class="control has-icons-left">
            <input
              v-model="innerValue.last_name"
              @input="handleChange"
              :class="[{'is-danger': validateErrors.last_name}, 'input']"
              type="text"
              placeholder="Введите вашу фамилию">
            <span class="icon is-small is-left">
              <icon name="user" scale="1" class="el-icon-fa"/>
            </span>
          </div>
        </div>
        <div class="column">
          <div class="control has-icons-left">
            <input
              v-model="innerValue.first_name"
              :class="[{'is-danger': validateErrors.first_name}, 'input']"
              type="text"
              placeholder="Введите ваше имя">
            <span class="icon is-small is-left">
              <icon name="user" scale="1" class="el-icon-fa"/>
            </span>
          </div>
        </div>

        <div class="column">
          <div class="control has-icons-left">
            <input
              v-model="innerValue.middle_name"
              @input="handleChange"
              :class="[{'is-danger': validateErrors.middle_name}, 'input']"
              type="text"
              placeholder="Введите ваше отчество">
            <span class="icon is-small is-left">
              <icon name="user" scale="1" class="el-icon-fa"/>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label">E-mail</label>
      <div class="control has-icons-left">
        <input
          v-model="innerValue.email"
          @input="handleChange"
          :class="[{'is-danger': validateErrors.email}, 'input']"
          type="text"
          placeholder="Почтовый ящик необходим для связи с вами">

        <span class="icon is-small is-left">
            <icon name="envelope" scale="1" class="el-icon-fa"/>
        </span>
      </div>
    </div>

    <div class="field">
      <label class="label">Телефон</label>
      <div class="control has-icons-left">
        <input
          v-model="innerValue.phone"
          @input="handleChange"
          :class="[{'is-danger': validateErrors.phone}, 'input']"
          type="text"
          placeholder="Телефон необходим для более оперативной связи с вами">

        <span class="icon is-small is-left">
          <icon name="phone" scale="1" class="el-icon-fa"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import 'vue-awesome/icons/user'
  import 'vue-awesome/icons/phone'
  import 'vue-awesome/icons/envelope'

  /**
   * Форма ввода данных о покупателе.
   */
  export default {
    name: 'customer-step',

    props: {
      /**
       * Данные пользователя.
       */
      value: {
        type: Object,
        required: true
      },

      validateErrors: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        innerValue: _.cloneDeep(this.value)
      }
    },

    methods: {
      handleChange () {
        this.$emit('input', this.innerValue)
      }
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// CustomerStep.vue?d8b738e8